export default __webpack_public_path__ + "static/media/hong-kong.0c65b4d8.png";